export const CODABAR = 1;
export const CODE39 = 2;
export const CODE39_EXTENDED = 3;
export const CODE93 = 4;
export const CODE93_EXTENDED = 5;
export const CODE_128 = 6;
export const EAN8 = 7;
export const EAN13 = 8;
export const GS1_128 = 9;
export const UPC_A = 10;
export const UPC_E = 11;
export const AZTEC_CODE = 12;
export const DATAMATRIX = 13;
export const PDF417 = 14;
